<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-[#E6E4E4]">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 18.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-4.5-3.75a6 6 0 0 1 9 0m-12-3a10.5 10.5 0 0 1 15 0" />
</svg>
